import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RadioComponent } from './components/radio/radio.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ButtonComponent } from './components/button/button.component';
import { SkeletonLoadingComponent } from './components/skeleton-loading/skeleton-loading.component';
import { CollapseComponent } from './components/collapse/collapse.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { ToggleComponent } from './components/toggle/toggle.component';
import { ModalBannerComponent } from './components/modal-banner/modal-banner.component';
import { ToggleButtonComponent } from './components/toggle-button/toggle-button.component';
import { ModalComponent } from './components/modal/modal.component';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [RadioComponent, SpinnerComponent, ButtonComponent, SkeletonLoadingComponent, CollapseComponent, CheckboxComponent, ToggleComponent, ModalBannerComponent, ToggleButtonComponent, ModalComponent],
  imports: [
    CommonModule,
    IonicModule.forRoot(),
  ],
  exports: [RadioComponent, SpinnerComponent, ButtonComponent, SkeletonLoadingComponent, CollapseComponent, CheckboxComponent, ToggleComponent, ModalBannerComponent, ToggleButtonComponent, ModalComponent,],
})
export class UIToolkitModule { }
